import Vue from 'vue';

const success = (response, context) => {
    let keys = Object.keys(response.data.prices);
    context.rentals = response.data.rentals;
    if (keys.length > 0 ) {
        if(response.data.competitorsUrls.length > 0) {
          context.mainCompetitorUrls = response.data.competitorsUrls;
          context.competitorsUrls = context.mainCompetitorUrls;
        } else {
          context.competitorsUrls = [];
          context.mainCompetitorUrls = [{
            id: null,
            url: '',
            name: '',
            color: context.getRandomColor(),
            nbr_guests: context.defaultGuestCount,
            min_nights: context.defaultMinNight,
          }];
          context.mainCompetitorUrls.map(
            compUrl => context.competitorsUrls = [
              ...context.competitorsUrls,
              {...compUrl}
            ]
          );
          context.openModal('#competitors-rental-modal');
        }

        if(response.data.ownRentalUrl.color || !response.data.ownRentalUrl.url) {
          context.mainOwnRentalUrl = response.data.ownRentalUrl;
          context.ownRentalUrl = context.mainOwnRentalUrl;
        }

        if ((response.data.prices.competitors.length > 0 || response.data.prices.own_property.length > 0) && !context.alreadyRendered) {
            context.prices = response.data.prices;
            context.max = response.data.max;
            context.min = response.data.min;
            context.getMarketDataForPeriod();
            context.renderMarketChart(context.pricesData);
            context.noData = false;
            context.alreadyRendered = true;
        } else if (context.alreadyRendered) {
            context.prices = response.data.prices;
            context.max = response.data.max;
            context.min = response.data.min;
            context.getMarketDataForPeriod();
            context.updateChartData(context.chartMarket, context.pricesData);
            context.noData= false;
        }
    } else {
        context.mainCompetitorUrls = [{
          id: null,
          url: '',
          name: '',
          color: context.getRandomColor(),
          nbr_guests: context.defaultGuestCount,
          min_nights: context.defaultMinNight,
        }];
        context.competitorsUrls = context.mainCompetitorUrls;

        context.mainOwnRentalUrl = {
          url: '',
          name: '',
          color: context.getRandomColor(),
          nbr_guests: context.defaultGuestCount,
          min_nights: context.defaultMinNight,
        };
        context.ownRentalUrl = context.mainOwnRentalUrl;
        context.prices = [];
        context.noData= true;
    }
    context.loading = false;
};

const failed = (error, context) => {
    context.loading = false;
    context.noData= true;
};

export default (url, context) => {
    return Vue.$http.get(url)
        .then((response) => {
            if (response.status === 200) {
                success(response, context);
            } else {
                failed();
            }
        })
        .catch((error) => {
            failed(error, context);
        });
};



// WEBPACK FOOTER //
// ./src/app/services/analytics/getMarketTab.js